export const CheckCircleIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="inherit">
        <g clip-path="url(#clip0_1987_219)">
            <path d="M13.9637 7.89507L15.1337 9.08257L10.3062 13.8384C9.98375 14.1609 9.55958 14.3217 9.13375 14.3217C8.70791 14.3217 8.27958 14.1592 7.95375 13.8342L5.63541 11.5876L6.79625 10.3901L9.12375 12.6459L13.9637 7.89507ZM20.3821 10.9884C20.3821 16.5026 15.8962 20.9884 10.3821 20.9884C4.86791 20.9884 0.38208 16.5026 0.38208 10.9884C0.38208 5.47424 4.86791 0.988403 10.3821 0.988403C15.8962 0.988403 20.3821 5.47424 20.3821 10.9884ZM18.7154 10.9884C18.7154 6.3934 14.9771 2.65507 10.3821 2.65507C5.78708 2.65507 2.04875 6.3934 2.04875 10.9884C2.04875 15.5834 5.78708 19.3217 10.3821 19.3217C14.9771 19.3217 18.7154 15.5834 18.7154 10.9884Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_1987_219">
            <rect width="20" height="20" fill="white" transform="translate(0.38208 0.988403)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
